import createHeartComponent, { type SaveAdProps } from "@finn-no/favorite-heart-component";
import React from "react";

type FavoriteHeart = ReturnType<typeof createHeartComponent>;

const FavoriteHeartContext = React.createContext<FavoriteHeart | null>(null);

type FavoriteHeartProviderProps = {
	children: React.ReactNode;
	loginId?: number;
};

export function FavoriteHeartProvider(props: FavoriteHeartProviderProps) {
	const { children, loginId } = props;

	const Heart = createHeartComponent({
		baseUri: "/favorite-frontend-api",
		renderServerSide: true,
		userId: loginId,
	});

	return <FavoriteHeartContext.Provider value={Heart}>{children}</FavoriteHeartContext.Provider>;
}

type FavoriteHeartProps = Omit<SaveAdProps, "itemId" | "itemType"> & {
	itemId: string;
	isMobile: boolean;
};

export function FavoriteHeart(props: FavoriteHeartProps) {
	const { itemId, isMobile, ...passThroughProps } = props;

	const Heart = React.useContext(FavoriteHeartContext);

	if (!Heart) {
		throw new Error("FavoriteHeart must be used within an FavoriteHeartProvider");
	}

	return <Heart isMobile={isMobile} itemId={itemId as unknown as number} itemType="Ad" {...passThroughProps} />;
}
